<template>
  <div
    class="botm-bar-wrap"
    v-if="!showFetchLocationModal"
    :class="{ mt80: appliedOfferPromo }"
  >
    <!-- 'active' class is added when item added to cart -->
    <div
      class="bottom-nav flex-column"
      :class="[
        getPositionClass,
        isOnMenuPage ? 'zIndex0' : '',
        appliedOfferPromo ? 'offer-applied' : '',
      ]"
      v-if="
        !isSearchOrFavouritesPage &&
        (this.cartQuantity || (appliedOfferPromo && welcomeOffers?.length))
      "
    >
      <!-- promo-offer-nudges -->
      <div v-if="appliedOfferPromo">
        <div
          class="promo-offer-bar color-green-offer"
          :class="[isOfferSelected ? 'promo-offer-bar-active' : '']"
          @click="triggerOfferDetailsModal"
        >
          <div class="d-flex align-items-center">
            <img :src="staticImgBaseUrl + '/images/global/percentStar.svg'" />
            <div class="d-flex">
              <span class="fs-12 pl8 fw-700">
                {{ appliedOfferPromo }} Applied!
              </span>
              <span class="fs-12 pl4">{{ appliedOfferDescription }}</span>
            </div>
          </div>
          <div @click="triggerOfferDetailsModal">
            <i aria-hidden="true" class="hkfi-arrow-line fs-14 tr"></i>
          </div>
        </div>
      </div>
      <div v-if="this.cartQuantity" class="flex-row justify-content-between">
        <div class="price-wrap">
          <div>
            {{ this.cartQuantity }}
            {{ this.cartQuantity > 1 ? "Items" : "Item" }}
          </div>
          <div class="cart-total-wrap d-flex">
            <span class="fs-20 bold mr5"
              ><i class="rs">Rs.</i>{{ this.cartTotal }}</span
            >
            <div class="savings" v-if="cartSavings">
              <span class="fw-700">Saving</span>
              <span class="fs-12 normal">
                <i class="rs">Rs.</i
                ><span class="fw-700">
                  {{
                    this.cartSavings % 1 === 0
                      ? this.cartSavings
                      : this.cartSavings.toFixed(2)
                  }}
                </span>
              </span>
            </div>
            <!-- <span class="fs-11 color-grey-light mr5"
              ><i class="rs">Rs.</i>
              <span class="striked-text">{{ this.cartTotal }}</span></span
            > -->
            <!-- <span class="fs-10 color-slaty">plus taxes</span> -->
          </div>
        </div>
        <div class="">
          <button
            class="btn checkout-cta hand secondary"
            @click="handleCartClick"
            v-ripple
          >
            {{ viewCartCta }}
          </button>
        </div>
      </div>
    </div>

    <!-- bottom bar for cart in search page -->
    <div
      class="bottom-nav-focused plr16"
      :class="{ active: cartQuantity > 0 }"
      v-if="isSearchOrFavouritesPage && cartQuantity > 0"
    >
      <span class="nav-item" @click="handleCartClick($event)" v-ripple>
        <div
          v-if="cartQuantity >= 0"
          class="btn btn-checkout disp-col-inline secondary"
        >
          <span class="mr3">
            <transition name="slide-fade" mode="out-in">
              <span :key="cartQuantity">
                {{ cartQuantity }}
                {{ cartQuantity > 1 ? "items" : "item" }}</span
              >
            </transition>
            <i aria-hidden="true" class="jfi-cart fs-18"></i>
          </span>
          <div>
            <span class="bold ml12 mr15">View Cart</span>
            <i aria-hidden="true" class="hkfi-arrow-line fs-10"></i>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import {
  EVENT_CLICK_VIEWCART,
  EVENT_OFFER_NUDGE,
  EVENT_POPUP,
} from "../helpers/analyticsEvents";

export default {
  name: "BottomBar",
  props: ["moduleProps"],
  components: {},
  data() {
    return {
      staticImgBaseUrl,
      selectedPromoIndex: -1,
      isEnd: false,
      clientPlatform,
      viewCartCta: "",
      modulePropsData: [],
    };
  },
  mounted() {
    this.modulePropsData = Utility.tryJsonParse(this.moduleProps, []);
    this.viewCartCta = this.modulePropsData?.viewCartCta;
    if (clientPlatform == "Web" && window.location.href?.includes("/store/")) {
      let options = {
        root: null,
        threshold: 1,
      };

      const callback = (entries) => {
        this.isEnd = entries[0].isIntersecting;
      };

      if (document.querySelector("#end")) {
        let observer = new IntersectionObserver(callback, options);
        observer.observe(document.querySelector("#end"));
      }
    }
    if (this.$store?.state?.Offers?.appliedOfferPromo) {
      EVENT_OFFER_NUDGE({
        userAction: "click",
        subcategory:
          this.$store.state.Offers.appliedOfferPromo + "coupon selected",
      });
    }
  },
  methods: {
    handleCartClick() {
      EVENT_CLICK_VIEWCART();
      LocalStorageFunc.setEmptyCartRedirection(location.href);
      Utility.sendToCartScreen();
    },
    triggerOfferDetailsModal() {
      EVENT_OFFER_NUDGE({
        userAction: "click",
        subcategory: this.appliedOfferPromo + "coupon selected",
      });
      EVENT_POPUP({
        subcategory: "alert",
        errorMessage: this.appliedOfferPromo + "coupon selected",
      });
      // Utility.sendToOffersScreen();
      document.body.classList.add("body-stop-scroll-mobile");

      this.$store.commit(keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG, true);

      this.appliedOfferPromo &&
        this.$store.state.Offers.offersList?.map((i, index) => {
          if (i.couponCode == this.appliedOfferPromo) {
            this.selectedPromoIndex = index;
            this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
              campaignId: i.campaignId,
            });
          }
        });

      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
        this.selectedPromoIndex,
      );

      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_FROM_BOTTOM_BAR,
        true,
      );
    },
  },
  computed: {
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CART_QUANTITY];
    },
    cartTotal() {
      return this.$store.getters[keyMapsGetter.CART_TOTAL];
    },
    cartSavings() {
      return this.$store.getters[keyMapsGetter.CART_SAVINGS];
    },
    isOfferSelected() {
      return LocalStorageFunc.getCouponCode()?.code !== undefined
        ? true
        : false;
    },
    appliedOfferDescription() {
      return this.$store.state.Offers.offersList.length
        ? this.$store.state.Offers.offersList?.find(
            (x) => x.couponCode == this.appliedOfferPromo,
          )?.metaData?.shortSavingsMessage
        : "";
    },
    isSearchOrFavouritesPage() {
      return (
        Utility.isCurrentlyAtUrl("/search") ||
        Utility.isCurrentlyAtUrl("/my-favourites")
      );
    },
    isNotificationVisible() {
      return this.$store.state.Notification.notificationVisibilityStatus;
    },
    getNotificationPosition() {
      return this.$store.state.Notification.notificationPosition;
    },
    getPositionClass() {
      if (
        this.isNotificationVisible &&
        this.cartQuantity > 0 &&
        this.getNotificationPosition == "show-notif-bottom-big"
      ) {
        return "move-up-inline-cart-big active";
      } else if (
        this.isNotificationVisible &&
        this.cartQuantity > 0 &&
        this.getNotificationPosition == "show-notif-bottom"
      ) {
        return "move-up-inline-cart active";
      } else if (
        this.cartQuantity > 0 &&
        this.isEnd &&
        clientPlatform == "Web"
      ) {
        return "active b315";
      } else if (this.cartQuantity > 0) {
        return "active";
      }
      return "";
    },
    appliedOfferPromo() {
      this.$store.state.Offers.appliedOfferPromo
        ? EVENT_OFFER_NUDGE({
            userAction: "click",
            subcategory:
              this.$store.state.Offers.appliedOfferPromo + "coupon selected",
          })
        : "";
      return this.$store.state.Offers.appliedOfferPromo;
    },
    isOnMenuPage() {
      return Utility.isCurrentlyAtUrl("/menu");
    },
    isOnHomePage() {
      return Utility.isCurrentlyAtUrl("/store");
    },
    showFetchLocationModal() {
      return this.isOnHomePage
        ? this.$store.state.Location.showFetchLocationModal
        : false;
    },
  },
};
</script>
